import React from 'react';
import './Chapters.scss';

function Chapter5() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        Equally important for the TSI team, the AWS cloud comes equipped with state-of-the-art data
        security protections and adherence to compliance standards, such as HIPPA, NIST—all with
        configurable access controls on the RONIN interface.
      </p>
      <p className="chapter__paragraph">
        “Even as an IT person, when I first logged into the AWS dashboard, the amount of choice, the
        pace that Amazon innovates at and brings new services to market [was] astonishing,” RONIN
        CEO and Founder Nathan Albrighton said in a recent{' '}
        <a href="https://www.youtube.com/watch?v=VHCn5zynDk4" target="_blank" rel="sponsored">
          presentation
        </a>
        . With its seamless interface for data management, researchers, like those with the TSI
        team, can harness the power of AWS while preserving their time, money, and energy for
        analyzing the data that counts.
      </p>
      <p className="chapter__paragraph">
        “Conservation is not cheap, and funding is not limitless,” says Dr. Hogg. “So how do you
        maximize the very small amount of dollars you have in the most efficient way possible? AWS
        and RONIN let us determine how much money each part of the analysis is going to cost…so we
        can maximize our conservation dollars.”
      </p>
    </section>
  );
}

export default Chapter5;
